export default "__VITE_ASSET__0b5b9c91__"